import request from "../utils/request";

export function getClassList() {
  return request({
    url: "/sc-basic-merchant-backend/faq/query/categoryList",
    method: "get",
  });
}

export function saveClass(data) {
  return request({
    url: "/sc-basic-merchant-backend/faq/createOrUpdate/category",
    method: "post",
    data,
  });
}
export function getClassDetail(id) {
  return request({
    url: `/sc-basic-merchant-backend/faq/query/categoryById?id=${id}`,
    method: "get",
  });
}

export function deleteClass(data) {
  return request({
    url: `/sc-basic-merchant-backend/faq/delete/category`,
    method: "post",
    data,
  });
}

export function sortClass(data) {
  return request({
    url: `/sc-basic-merchant-backend/faq/sort/categoryList`,
    method: "post",
    data,
  });
}

//取对应id、下的问题
export function getQuestions(id) {
  return request({
    url: `/sc-basic-merchant-backend/faq/query/problemList?faqCategoryId=${id}`,
    method: "get",
  });
}

//  问题排序
export function sortQuestion(data) {
  return request({
    url: `/sc-basic-merchant-backend/faq/sort/problemList`,
    method: "post",
    data,
  });
}

//删除问题
export function deleteQuestion(data) {
  return request({
    url: `/sc-basic-merchant-backend/faq/delete/problem`,
    method: "post",
    data,
  });
}

// 创建或更新问题
export function creatOrUpdateQuestion(data) {
  return request({
    url: "/sc-basic-merchant-backend/faq/createOrUpdate/problem",
    method: "post",
    data,
  });
}

// 获取问题详情
export function getQuestionDetail(id) {
  return request({
    url: `/sc-basic-merchant-backend/faq/query/problemById?id=${id}`,
    method: "get",
  });
}
